import type { AxiosError } from 'axios';
import axiosInstance from './interceptor.services';

export type TOrderChangeMode = 'same_for_all' | 'per_day';

export interface IOrderChangeSettings {
  mode: TOrderChangeMode;
  allowCancellation: boolean;
  allowModification: boolean;
  leadMinutes: number | null;
  leadByWeekday?: Record<string, number>;
}

export interface IUpdateOrderChangeSettingsPayload {
  mode: TOrderChangeMode;
  allowCancellation: boolean;
  allowModification: boolean;
  leadMinutes: number | null;
  leadMinutesByWeekday: Record<string, number>;
}

export const OrderChangeService = {
  getSettings: async (storeId: string) => {
    try {
      const response = await axiosInstance.get<{ data: IOrderChangeSettings }>(
        `restaurants/${storeId}/order-change`,
      );
      return response;
    } catch (error) {
      const err = error as AxiosError;
      return Promise.reject(err);
    }
  },

  updateSettings: async (
    storeId: string,
    payload: IUpdateOrderChangeSettingsPayload,
  ) => {
    try {
      const response = await axiosInstance.put<{ message: string }>(
        `restaurants/${storeId}/order-change`,
        payload,
      );
      return response;
    } catch (error) {
      const err = error as AxiosError;
      return Promise.reject(err);
    }
  },
};
